import { formatDate, generateUrl } from '.'
import config from '../../config.json'
import dayjs from 'dayjs'

export function thumbnailSrc(thumbnail) {
    if (!thumbnail?.file?.hash) return null

    if (thumbnail?.title)
        return `/api/filedb/${thumbnail.file.hash}/${thumbnail.title.split('.')[0]}.${thumbnail.file.ext}`

    return `/api/filedb/${thumbnail.file.hash}.${thumbnail.file.ext}`
}

export function posterSrc(media) {
    if (!media?.file?.hash) return null

    return `/api/filedb/${media.file.hash}c.jpg`
}

export function getNewsContent(news, inlineNews = [], t, ads = [], options) {
    if (!news?.content) return ''
    const contentBlocks = news.content.split('</p>').map(c => `${c}</p>`)
    let insertContentAt = { 1: [], 2: [], 3: [], 4: [], 5: [], 6: [], 7: [] }

    if (config.integrations?.yektanet?.hamsan?.inline)
        insertContentAt[1].push(`<div class="inline-1">${config?.integrations?.yektanet?.hamsan?.inline}</div>`)

    if (config.integrations?.yektanet?.hamsan?.id_inline2)
        insertContentAt[2].push(`<div class="inline-2">${config.integrations.yektanet.hamsan.inline2}</div>`)

    if (config.integrations?.yektanet?.hamsan?.id_inline3)
        insertContentAt[3].push(`<div class="inline-3">${config.integrations.yektanet.hamsan.inline3}</div>`)

    if (config.integrations?.yektanet?.hamsan?.id_inline5)
        insertContentAt[5].push(`<div class="inline-5">${config.integrations.yektanet.hamsan.inline5}</div>`)

    if (config.integrations?.yektanet?.hamsan?.id_inline7)
        insertContentAt[7].push(`<div class="inline-7">${config.integrations.yektanet.hamsan.inline7}</div>`)

    if (config.integrations?.sanjagh?.hamsan?.id_inline)
        insertContentAt[1].push(`<div><div id="${config.integrations.sanjagh.hamsan.id_inline}"></div></div>`)

    if (config.integrations?.mediaad?.hamsan?.id_inline)
        insertContentAt[1].push(`<div><div id="${config.integrations.mediaad.hamsan.id_inline}"></div></div>`)

    const inlineAds = ads.filter(a => a.location && a.location.indexOf('news_inline_p') === 0)
    for (const ad of inlineAds) {
        const paragraph = Number(ad.location.replace('news_inline_p', ''))
        insertContentAt[paragraph].push(ad.content)
    }
    let additions = 0
    for (const [position, adsToInsert] of Object.entries(insertContentAt)) {
        if (!adsToInsert.length) continue
        contentBlocks.splice(
            Number(position) + additions++,
            0,
            `<div id="inlinead${position}" data-adtitle="میان متنی پاراگراف ${position}">${adsToInsert.join('\n')}</div>`
        )
    }

    if (inlineNews?.length > 0) {
        const inlinenewsTemplate = `<div
        style="
            background-color: #fefae0;
            padding: 20px;
            border-radius: 0.5rem;
            border: 1px solid #faedcd;
            margin: 10px 0;
        "
    >
        <h3
            style="
                color: #990F00;
                font-size: 1.5rem;
            "
        >
            ${t('در میان اخبار', { ns: 'news' })}
        </h3>
        <ul
            style="
                list-style-type: circle;
                list-style: inside;
                color: #FF5A47;
                font-size: 1rem;
                line-height: 1.6rem;
                margin-top: 10px;
                ${options?.inlineNewsStyleStr}
            "
        >
        ${inlineNews
                .map(
                    (n) => `
            <li>
                <a ${n.forward_link ? 'rel="nofollow"' : ''
                        } href="${generateUrl(n, 'news')}" style="${options?.inlineNewsLinkStyleStr}">
                    ${n.title}
                </a>
            </li>
            `
                )
                .join('')}
        </ul>
    </div>`
        contentBlocks.splice(Math.ceil(contentBlocks.length / 2), 0, inlinenewsTemplate)
    }
    return `${news.newsTemplateTop?.content ?? ''}${contentBlocks.join('')}${news.newsTemplateBottom?.content ?? ''}`
}

export function newsDisplayedPubDate(news, format = 'YYYY/MM/DD HH:mm') {
    if (!news?.published_at && !news?.selected_published_at) return null
    let date = dayjs(news.selected_published_at ?? news.published_at)
    if (!date.isValid()) return null
    // no need as selected_published_at is not time corrected
    // if (Number(news.timecorrection)) date = date.add(Number(news.timecorrection) * -1, 'minute')
    if (format === 'iso') return date.toISOString()
    if (format === 'date') return date.toDate()
    return formatDate(date, format)
}